import { MailOutlined } from "@ant-design/icons";
import { Button, Input, Checkbox, Form } from "antd";
import React from "react";

const LoginForm = ({
  email,
  setKeepMeLogin,
  keepMeLogin,
  setEmail,
  loading,
  onSubmit,
  verifyingEmail = false,
  disabled = false,
}) => {
  const onEmailChange = ({ target }) => setEmail(target.value);
  const onKeepMeLoginChange = ({ target }) => {
    setKeepMeLogin(target.checked);
  };

  const formLabel = verifyingEmail
    ? "Please enter your email id again to verify login link"
    : "Enter your email to get started";

  return (
    <Form layout="vertical" onFinish={onSubmit}>
      <Form.Item label={formLabel}>
        <Input
          placeholder="Email"
          type="email"
          prefix={<MailOutlined style={{ color: "rgba(0,0,0,.25)" }} />}
          value={email}
          onChange={onEmailChange}
          disabled={disabled}
        />
      </Form.Item>
      <Form.Item style={{ textAlign: "left" }}>
        <Checkbox
          onChange={onKeepMeLoginChange}
          style={{ marginRight: "5px" }}
          checked={keepMeLogin}
          defaultChecked
        />
        Keep Me Logged in for 30 days
      </Form.Item>

      <Form.Item>
        <Button
          type="primary"
          htmlType="submit"
          loading={loading}
          disabled={disabled}
        >
          {verifyingEmail ? "Verify email" : "Get Sign-in link"}
        </Button>
      </Form.Item>
    </Form>
  );
};

export { LoginForm };
